import React from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import Acciona2CheckButton from '../../../../../../components/Acciona2CheckButton';
import AccionaButton from '../../../../../../components/AccionaButton';
import AccionaCheckButton from '../../../../../../components/AccionaCheckButton';
import AccionaFormItem from '../../../../../../components/AccionaFormItem';
import AccionaInput from '../../../../../../components/AccionaInput';
import AccionaDropdownSelectable from '../../../../../../components/AccionaDropdownSelectable';
import { useNavigate, useParams } from 'react-router-dom';
import { Upload } from 'antd';
import { upload } from './form.module.scss';
import { createFileOnBackend } from '../../../../../../services/api/files';
import { updateDeliveryNotesFileExtensionsButton } from '../../../../../../constants/general';

const DeliveryForm = ({
  formState,
  updateForm,
  moveAllRegions,
  updateMoveAllRegions,
  forceTooltip,
  children,
  hideMoveAllRegionsButton,
  onImageLoaded,
}) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { validated, fileName, id: pid } = useParams();
  const onBack = () => {
    return document.referrer.toLowerCase().includes('ehe')
      ? window.location.assign(document.referrer)
      : navigate(-1);
  };
  const isANoValidatedAndXlsxDeliveryNote =
    validated === 'noValidated' && fileName.includes('xlsx');
  return (
    <div className="wrapper" style={{ maxWidth: '1524px' }}>
      <div className="form-row">
        <AccionaButton
          msg={intl.formatMessage({ id: 'back' })}
          onClick={onBack}
          classIcon="icon fas fa-chevron-left"
          style={{ float: 'right', marginTop: '30px', marginRight: '-15px' }}
        />
      </div>
      <div className="row row-project">
        <div className="col-xs-12 col-sm-3 col-md-3">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <AccionaFormItem>
              <AccionaInput
                disabled
                state={formState.templateName}
                label="templateName"
                onChange={updateForm}
              />
            </AccionaFormItem>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12">
            <AccionaFormItem>
              <AccionaInput
                disabled
                state={formState.supplier_id}
                label="supplier_id"
                onChange={updateForm}
              />
            </AccionaFormItem>
          </div>
          <div
            className="col-xs-12 col-sm-12 col-md-12"
            style={{
              width: '100%',
              minHeight: '91.7px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {isANoValidatedAndXlsxDeliveryNote && (
              <Upload
                maxCount={1}
                accept={updateDeliveryNotesFileExtensionsButton}
                rootClassName={upload}
                customRequest={({ file, onError, onSuccess }) => {
                  createFileOnBackend(file, 'delivery', pid, false)
                    .then(({ data }) => {
                      onSuccess(data, file);
                      onImageLoaded(data, file);
                    })
                    .catch(onError);
                }}
                onRemove={() => {
                  onImageLoaded(undefined, undefined);
                }}
              >
                <AccionaButton
                  msg={intl.formatMessage({ id: 'uploadDeliveryNote' })}
                  type="primary"
                  style={{ width: '100%', margin: 0 }}
                  classIcon="fas fa-file-upload"
                />
              </Upload>
            )}
            {!hideMoveAllRegionsButton && (
              <AccionaCheckButton
                active={moveAllRegions}
                updateActive={updateMoveAllRegions}
                msg={intl.formatMessage({ id: 'moveAllRegions' })}
              />
            )}
          </div>
        </div>
        <div className="col-xs-12 col-sm-9 col-md-9">
          <div className="col-xs-12 col-sm-4 col-md-4">
            <AccionaFormItem forceTooltip={forceTooltip}>
              <AccionaInput
                state={formState.arriving_time}
                label="arriving_time"
                onChange={updateForm}
              />
            </AccionaFormItem>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4">
            <AccionaFormItem forceTooltip={forceTooltip}>
              <AccionaInput
                state={formState.start_discharging_time}
                label="start_discharging_time"
                onChange={updateForm}
              />
            </AccionaFormItem>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4">
            <AccionaFormItem forceTooltip={forceTooltip}>
              <AccionaInput
                state={formState.finish_discharging_time}
                label="finish_discharging_time"
                onChange={updateForm}
              />
            </AccionaFormItem>
          </div>
        </div>
        <div className="col-xs-12 col-sm-9 col-md-9">
          <div className="col-xs-12 col-sm-3 col-md-3">
            <AccionaFormItem forceTooltip={forceTooltip}>
              <Acciona2CheckButton
                state={formState.mash_control}
                label="mash_control"
                onChange={updateForm}
              />
            </AccionaFormItem>
          </div>
          <div className="col-xs-12 col-sm-3 col-md-3">
            <AccionaFormItem
              forceTooltip={forceTooltip}
              hidden={!formState.mash_control.value}
            >
              <AccionaInput
                state={formState.specimens_number}
                label="specimens_number"
                onChange={updateForm}
                disabled={!formState.mash_control.value}
              />
            </AccionaFormItem>
          </div>
          <div className="col-xs-12 col-sm-3 col-md-3">
            <AccionaFormItem
              forceTooltip={forceTooltip}
              hidden={!formState.mash_control.value}
            >
              <AccionaInput
                state={formState.slump}
                label="slump"
                onChange={updateForm}
                disabled={!formState.mash_control.value}
              />
            </AccionaFormItem>
          </div>
          <div className="col-xs-12 col-sm-3 col-md-3">
            <AccionaFormItem
              forceTooltip={forceTooltip}
              hidden={!formState.mash_control.value}
            >
              <Acciona2CheckButton
                state={formState.mash_control_extra}
                label="mash_control_extra"
                onChange={updateForm}
                disabled={!formState.mash_control.value}
              />
            </AccionaFormItem>
          </div>
        </div>
        <div className="col-xs-12 col-sm-9 col-md-9">
          <div className="col-xs-12 col-sm-6 col-md-6">
            <AccionaFormItem forceTooltip={forceTooltip}>
              <AccionaDropdownSelectable
                label="elements"
                state={formState.elements}
                onChange={updateForm}
              ></AccionaDropdownSelectable>
            </AccionaFormItem>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6">
            <AccionaFormItem forceTooltip={forceTooltip}>
              <AccionaInput
                state={formState.detailed_location}
                label="detailed_location"
                onChange={updateForm}
              />
            </AccionaFormItem>
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

DeliveryForm.propTypes = {
  formState: PropTypes.object.isRequired, // TODO: Complete with shape()
  updateForm: PropTypes.func.isRequired,
  moveAllRegions: PropTypes.bool.isRequired,
  updateMoveAllRegions: PropTypes.func.isRequired,
  forceTooltip: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  hideMoveAllRegionsButton: PropTypes.bool,
  onImageLoaded: PropTypes.func,
};

DeliveryForm.defaultProps = {
  hideMoveAllRegionsButton: false,
  onImageLoaded: () => {},
};

export default DeliveryForm;
